<div class="article-selector article-selector-2" [ngClass]="isLast?'isLast':''">
  <div>{{ counter.name | translate }}</div>
  <div>
    <app-count-button [disabled]="!canCountDown" [faIcon]="faMinus" (singleClick)="onClickCountChangeByOne(false)" cssClass="edit-counter" [ngClass]="{'fa-disabled': !canCountDown}"></app-count-button>
    <span *ngIf="!isLocked" >{{ counter.count }}</span>
    <fa-icon *ngIf="isLocked" class="locked-icon" [icon]="faLock" (click)="onClickCountChangeByOne(true)"></fa-icon>
    <app-count-button [disabled]="!canCountUp" [faIcon]="faPlus" (singleClick)="onClickCountChangeByOne(true)" cssClass="edit-counter" [ngClass]="{'fa-disabled': !canCountUp}"></app-count-button>
  </div>
</div>
